/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React, { Suspense, lazy } from "react";
import { graphql, StaticQuery } from "gatsby";
import { Container } from "react-bootstrap";
import { ToastContainer } from "react-toastify";

import "../utils/fontawesome";
import Footer from "./footer";
import "react-toastify/dist/ReactToastify.css";
import { Script } from "gatsby";

import Navbar from "./navBarCssBU";

// const Navbar = lazy(() => import("./navBarCssBU"));

const Layout = ({ children, pageInfo }) => {
  // const isSSR = typeof window === "undefined";
  return (
    <>
      <StaticQuery
        query={graphql`
          query HeaderQuery {
            site {
              siteMetadata {
                title
                header {
                  mainTitle
                  subtitle
                }
              }
            }
          }
        `}
        render={data => (
          <>
            {process.env.BUILD_ENV === "production" ? (
              <>
                <Script src="/js/gtagtop.js" strategy="post-hydrate" />
                <noscript>
                  <iframe
                    title="gtag"
                    src="https://www.googletagmanager.com/ns.html?id=GTM-5PJRH3C"
                    style={{
                      display: "none",
                      visibility: "hidden"
                    }}
                    height="0"
                    width="0"
                  ></iframe>
                </noscript>
              </>
            ) : null}

            <div className="main-site-content">
              <Container fluid className="px-0 main">
                {/* {!isSSR && (
                  <Suspense fallback={<div className="fakenavbar"></div>}> */}
                    <Navbar pageInfo={pageInfo} />
                  {/* </Suspense>
                )} */}
                <main>{children}</main>
                <Footer />
                <ToastContainer position="bottom-right" autoClose={3000} hideProgressBar closeOnClick pauseOnHover />
              </Container>
            </div>
          </>
        )}
      />
    </>
  );
};

export default Layout;
